export enum $paginatedResponse {
  _total = '_total',
  data = 'data',
}

export interface IPaginatedResponse<T> {
  [$paginatedResponse._total]: number;
  [$paginatedResponse.data]: T[];
}
